import {
  type ButtonProps,
  Button as DSButton,
  type LinkProps,
} from "@opensea/ui-kit"
import type React from "react"
import { Link } from "../Link"

export function Button(props: ButtonProps) {
  return (
    <DSButton renderLink={Link as React.ComponentType<LinkProps>} {...props} />
  )
}
